import convertList from '../convertList';
import filters from '../filters';

function getList() {
    return new Promise((resolve, reject) => {
        qdp.getTroopList({
            success(res) {
                resolve(res);
            },
            fail(res) {
                reject(res);
            }
        });
    });
}

export default function(config) {
    const selfConfig = (config.extendConfig && config.extendConfig[config.base.field]) || {};
    return new Promise((resolve, reject) => {
        getList().then(
            res => {
                if (res.data.list && res.data.list.length) {
                    let { list } = res.data;
                    list = filters.filterTroopList(list, selfConfig);
                    list = list.map(x => {
                        return {
                            ...x,
                            loaded: true,
                            id: x.uuid
                        };
                    });
                    // const merConfig = Object.assign(config, moreConfig);

                    const cList = convertList(list, {
                        list: 'groupList',
                        groupName: 'groupName'
                    });

                    resolve(cList);
                } else {
                    resolve([]);
                }
            },
            err => {
                reject(err);
            }
        );
    });
}

// 老版本获取群的方式 CGI
// export default function(config){
//   return new Promise((resolve,reject) => {
//     _getGroupListFromNative().then((response) => {
//       let data = response;
//       let groupCount = 0;
//       let moreConfig = config || {};
//       data.filter = config.filter || 0;
//       data.groupList &&
//         data.groupList.forEach(group => {
//           groupCount += group.groupCode.length;
//         });
//       if (groupCount) {
//         _getGroupNicheConfig(data).then(
//           res => {
//             if (window.parseInt(res.code) === 0 && res.data && res.data.records) {
//               let list = [];
//               res.data.records.forEach(group => {
//                 if (group && group.groupList && group.groupList.length) {
//                   list.push(group);
//                 }
//               });
//               resolve(convertList(list, {
//                 list: 'groupList',
//                 groupName: 'groupName'
//               }, moreConfig));
//             }else{
//               reject(res);
//             }
//           },
//           err => {
//             reject(err);
//           }
//         );
//       } else {
//         resolve([]);
//       }
//     }, (err) => {
//       reject(err);
//     });
//   });
// }
// function _getGroupListFromNative(){
//   return new Promise((resolve,reject) => {
//     qdp.getGroupList({
//       success: function(res) {
//         resolve(res);
//       },
//       fail: function(res) {
//         reject(res);
//       }
//     });
//   });
// }
// function _getGroupNicheConfig(params) {
//   return Vue.prototype.$ajax.post('/cl/b2b/getTroopDetail', params);
// }
